module.exports = __webpack_public_path__ + "img/Menu-14.8771bec9.png";